import React from 'react'
import { affectedTitle, affectedLine, affectedRow, affectedByDay } from './affected'
import { dateSaid } from './repeat'
import './Repeat.css'

// Time off over bookings: before leave or a block is saved, the bookings it
// lands on, by day. Each has Move (opens the booking to change it) and
// Message (the client's Messages). Saving is still allowed; the bookings
// stay where they are until someone moves them.
const AffectedBookings = ({ list, until, onMove, onMessage }) => {
  if (!list || !list.length) return null
  const days = affectedByDay(list)
  return (
    <div className="rpt-aff" role="status" aria-live="polite">
      <p className="rpt-aff-title">{affectedTitle(list)}</p>
      <p className="rpt-aff-line">{affectedLine(list, until)}</p>
      <div className="rpt-visits">
        {days.map(day => (
          <div key={day.date} className="rpt-month">
            {days.length > 1 && <p className="rpt-month-name">{dateSaid(day.date)}</p>}
            <ul>
              {day.rows.map((b) => {
                const r = affectedRow(b)
                return (
                  <li key={r.id} className="rpt-visit is-overlap" data-booking={r.id}>
                    <span className="rpt-visit-ic" aria-hidden="true">!</span>
                    <span className="rpt-visit-main">
                      <span className="rpt-visit-date">
                        {r.who}
                        {r.repeat && <span className="rpt-tag">Repeat</span>}
                      </span>
                      <span className="rpt-visit-why">{r.when}{r.what ? ` · ${r.what}` : ''}</span>
                      {(onMove || (onMessage && r.canMessage)) && (
                        <span className="rpt-visit-acts">
                          {onMove && <button type="button" className="rpt-chip" onClick={() => onMove(b)}>Move</button>}
                          {onMessage && r.canMessage && <button type="button" className="rpt-chip" onClick={() => onMessage(b)}>Message {r.who.split(' ')[0]}</button>}
                        </span>
                      )}
                    </span>
                  </li>
                )
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AffectedBookings
